<template>
  <div>
    <div class="page-actions">
      <span>币种：</span>
      <el-select v-model="pair" placeholder="请选择币种">
        <el-option
          v-for="item in pairNames"
          :key="item.name"
          :label="item.name"
          :value="item.pair"
        ></el-option>
      </el-select>
      <span>是否排除机器人：</span>
      <el-switch v-model="isRemove"></el-switch>
      <el-button type="primary" @click="search()">搜索</el-button>
    </div>
    <div class="page-actions">
      <span
        >多空持仓差额：A = {{ X3D }} 持仓量 * {{ X3D }} 价格 - {{ X3K }} 持仓量
        * {{ X3K }} 价格</span
      >
      <span class="new-style" v-if="reslut > 0"
        >对冲账户应该持有的{{ X3D }}的金额为 {{ Math.abs(reslut) }}</span
      >
      <span class="new-style" v-else-if="reslut < 0"
        >对冲账户应该持有的{{ X3K }}的金额为 {{ Math.abs(reslut) }}</span
      >
      <span class="new-style" v-else>对冲账户不需要持有任何对冲产品</span>
    </div>
    <el-table :data="currencies">
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column prop="amount" label="用户持仓量"></el-table-column>
      <el-table-column prop="price" label="当前价格"></el-table-column>
      <el-table-column
        prop="totalPrice"
        label="用户持仓总金额"
      ></el-table-column>
    </el-table>
    <div>
      <p>说明：</p>
      <p>
        当多空持仓差额A的金额大于0时，此时用户持有的
        {{ X3D }}产品金额大于用户持有的{{
          X3K
        }}金额，此时为了避免BTC价格上涨给平台带来的亏损，
        我们应保持其他平台的对冲账号持有金额为A的 {{ X3D }}产品；
      </p>
      <p>
        当A小于0时，则情况相反，我们应保持对冲账号在其他平台持有金额为|A|的
        {{ X3K }}产品；
      </p>
      <p>
        当A等于0时，对冲账号不需持有任何对冲产品。
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'etf',
  data() {
    return {
      pair: '',
      isRemove: false
    };
  },

  computed: {
    ...mapState('etf', ['currencies', 'coinList']),
    Newpair() {
      return this.coinList.map(item => item.pair);
    },
    pairNames() {
      const map = this.Newpair.reduce((obj, item) => {
        const name = item.split(/3D_|3K_/)[0];
        obj[name] = obj[name] ? [item].concat(obj[name]) : [item];
        return obj;
      }, {});
      return Object.keys(map).map(key => ({
        name: key,
        pair: map[key]
      }));
    },
    X3D() {
      return (
        (this.currencies &&
          this.currencies.find(item => item.coinType.includes('3D'))) ||
        {}
      ).coinType;
    },
    X3K() {
      return (
        (this.currencies &&
          this.currencies.find(item => item.coinType.includes('3K'))) ||
        {}
      ).coinType;
    },
    reslut() {
      return (
        (
          (this.currencies &&
            this.currencies.find(item => item.coinType.includes('3D'))) ||
          {}
        ).totalPrice -
        (
          (this.currencies &&
            this.currencies.find(item => item.coinType.includes('3K'))) ||
          {}
        ).totalPrice
      );
    }
  },
  methods: {
    ...mapActions('etf', ['list']),
    search() {
      if (!this.pair) {
        this.$message({
          message: '币种不能为空',
          type: 'error'
        });
        return;
      }
      this.list({
        pair: this.pair.join(','),
        isRemove: this.isRemove
      });
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
.new-style {
  margin-left: 80px;
}
</style>
